export const timePanelHeaderText = "Pm7$ne";
export const meetNowHeaderText = "phH_L";
export const groupsPanelHeaderText = "Wxxprc";
export const notifNewItemsFmt = "LKVhuc";
export const updateAvailableHeaderText = "GxX7Ud";
export default {timePanelHeaderText,meetNowHeaderText,groupsPanelHeaderText,notifNewItemsFmt,updateAvailableHeaderText};